<!--邮箱/验证码登录弹框-->
<template>
  <div class="email-login-container">
    <!-- 登录弹框 -->
    <van-dialog
      v-model="loginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'3.36rem'"
    >
      <template #default>
        <div v-if="isPc" class="login-content-pc">
          <div class="title">{{content.loginEmailTitle}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <el-form class="maxHeight70 login-form-p beauty-scroll">
            <el-form-item :label="content.loginEmailLabel">
              <el-input
                v-model="loginForm.email"
                :maxlength="30"
                :placeholder="content.loginEmailTip">
                <template #append>
                  <span
                    v-if="!isCount"
                    style="color:#FF804C;font-size:0.16rem;cursor:pointer;"
                    @click="getSmsCode"
                  >{{content.loginGetCode}}</span>
                  <van-count-down
                    v-else
                    style="color:#FF804C;font-size:0.16rem;"
                    :time="countTime"
                    :format="`ss ${content.ss}`"
                    @finish="isCount=false"
                  />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item :label="content.loginVerificationLabel">
              <el-input
                v-model="loginForm.code"
                :maxlength="6"
                :placeholder="content.loginVerificationTip">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="loginBtn"
            :disabled="!(loginForm.email&&loginForm.code&&policyCheck)"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}</van-button>
          <!-- <van-button
            type="info"
            round
            class="visitorBtn"
            color="#05A6EB"
            plain
            hairline
            @click="visitorBtn"
          >{{content.loginInGuest}}</van-button> -->
        </div>
        <div v-else class="login-content">
          <div class="title">{{content.loginEmailTitle}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <van-field
            v-model="loginForm.email"
            type="text"
            center
            clearable
            maxlength="30"
            :placeholder="content.loginEmailTip"
          >
            <template #button>
              <span
                v-if="!isCount"
                style="color:#FF804C;font-size:0.16rem;cursor:pointer;"
                @click="getSmsCode"
              >{{content.loginGetCode}}</span>
              <van-count-down
                v-else
                style="color:#FF804C;font-size:0.16rem;"
                :time="countTime"
                :format="`ss ${content.ss}`"
                @finish="isCount=false"
              />
            </template>
          </van-field>
          <van-field
            v-model="loginForm.code"
            type="digit"
            size="small"
            maxlength="6"
            :placeholder="content.loginVerificationTip"
          />
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="loginBtn"
            :disabled="!(loginForm.email&&loginForm.code&&policyCheck)"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}</van-button>
          <!-- <van-button
            type="info"
            round
            class="visitorBtn"
            color="#05A6EB"
            plain
            hairline
            @click="visitorBtn"
          >{{content.loginInGuest}}</van-button> -->
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { postSendEmailCode, postEmailLogin } from '@/models/common'

export default {
  props:{
    streamId:{
      type: [Number, String],
      default: -1
    },
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCount: false, // 验证码倒计时
      loginShow: false, // 登录弹框
      loginForm: { // 登录框表单
        email: '',
        code: ''
      },
      policyCheck: false, // 同意协议
      countTime: 60000, // 验证码倒计时
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.loginShow = false
    },
    // 弹框
    showDialog() {
      this.loginShow = true
    },
    //获取验证码
    getSmsCode() {
      if (this.loginForm.email == '') {
        this.$toast(this.content.loginEmailTip) // 请输入邮箱
      } else if (/^\w+([\u4e00-\u9fa5-+.]*\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.loginForm.email)) {
        let domain_code = location.host.split('.')[1]
        postSendEmailCode({
          email: this.loginForm.email,
          type: 'LOGIN',
          domain_code
        }).then(res => {
          if (res.data.code == 0) {
            this.$toast(this.content.verificationSuccess)
            this.isCount = true
          } else {
            this.$toast(this.content.verificationFail)
          }
        })
      } else {
        this.$toast(this.content.loginEmailTip) // 请输入正确的邮箱
      }
    },
    // 游客身份观看
    visitorBtn() {
      this.$emit('visitorLogin')
    },
    // 查看隐私协议
    lookPolicy(){
      this.$emit('lookPolicy')
    },
    // 登录按钮
    loginBtn() {
      const _this = this
      if (String(this.loginForm.email).trim() && /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.loginForm.email) && this.loginForm.code && this.policyCheck) {
        postEmailLogin({
          live_stream_id: this.streamId,
          email: String(this.loginForm.email).trim(),
          code: String(this.loginForm.code).trim(),
        }).then(async res => {
          if (res.data.code == 0) {
            localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
            localStorage.setItem('x_token', res.data.data.token)
            // if (res.data.data.is_summit == 0) {
            //   _this.loginShow = false
            //   this.resetForm()
            //   this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.email })
            // } else {
            _this.$toast(_this.content.loginSuccess)
            _this.loginShow = false
            this.resetForm()
            this.$emit('loginSuccess', { id: res.data.data.id, email: _this.loginForm.email })
            // }
          } else {
            _this.$toast(_this.content.loginFail)
            this.$emit('loginFail')
          }
        })
      } else if(!this.policyCheck){
        this.$toast(this.content.needCheckPolicy)
      } else {
        this.$toast(this.content.correctEmialTip)
      }
    },
    resetForm() {
      this.loginForm = { // 登录框表单
        email: '',
        code: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.email-login-container {
  .login-content-pc {
    // height: 4rem;
    padding: 0 0.35rem;
    .login-form-p{
      padding: 0 0.4rem;
    }
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.3rem;
    }
    .close-icon {
      position: absolute;
      top: 0.33rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .van-cell {
      margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2A8AFA;
      }
      /deep/.van-checkbox__label {
        font-size: 0.17rem;
      }
      /deep/.van-icon{
        line-height: 1;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.2rem auto 0.3rem;
      display: block;
    }
    .visitorBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.1rem auto 0.3rem;
      border-style: solid;
      display: block;
    }
  }
  .login-content {
    // height: 4rem;
    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.2rem;
    }
    .close-icon {
      position: absolute;
      top: 0.23rem;
      right: 0.23rem;
      cursor: pointer;
    }
    .van-cell {
      margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2A8AFA;
      }
      /deep/.van-checkbox__label {
        font-size: 0.16rem;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.2rem auto 0.2rem;
      display: block;
    }
    .visitorBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.1rem auto 0.1rem;
      border-style: solid;
      display: block;
    }
  }
  .van-popup{
    position: absolute;
  }
}
</style>